<div class="row">
    <div class="col-xs-12 sub-categories-limited-wrap">
        @if (subCategories()?.length > 0) {
            <div class="pl-body pr-body mbr-8-24 mtr-16-32">
                <div class="is-flex content-center sub-categories-limited swiper-sub-categories">
                    <div class="swiper-nav swiper-subcat-nav-left swiper-subcat-{{ uuid }}-nav-left icon-white">
                        @if (direction() === 'rtl') {
                            <md-icon name="chevron-right"></md-icon>
                        } @else if (direction() === 'ltr') {
                            <md-icon name="chevron-left"></md-icon>
                        }
                    </div>
                    <div class="swiper-subcategories tabs" dir="direction" [ngClass]="swiperSubcategoriesClass">
                        <ul class="sub-categories-current-category swiper-wrapper">
                            @for (subcategory of subCategories(); track subcategory; let j = $index) {
                                <li
                                    class="swiper-slide"
                                    [ngClass]="{
                                        'is-active':
                                            currentCategoryFromABTest()?.locationPath === subcategory.locationPath ||
                                            (currentCategoryFromABTest()?.shortDescription === subcategory.shortDescription &&
                                                subcategory.shortDescription)
                                    }"
                                >
                                    <a
                                        class="align-middle text-l ttu blend-link"
                                        [href]="subcategory.locationPath"
                                        (click)="goToCategory(subcategory, $event)"
                                        [title]="subcategory.name + ' ' + lastSectionTranslated()"
                                    >
                                        {{ subcategory.name }}
                                        @if (showDebugCategoryIds()) {
                                            <div>({{ subcategory.id }})</div>
                                        }
                                        <!-- Información de depuración-->
                                        @if (showDebugCategoryIds()) {
                                            <category-debug [info]="'(' + subcategory.id + ')'" [template]="'parenthesis'"></category-debug>
                                        }
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                    <div class="swiper-nav swiper-subcat-nav-right swiper-subcat-{{ uuid }}-nav-right icon-white">
                        @if (direction() === 'rtl') {
                            <md-icon name="chevron-left"></md-icon>
                        } @else if (direction() === 'ltr') {
                            <md-icon name="chevron-right"></md-icon>
                        }
                    </div>
                </div>
            </div>
        }

        @if (showCategoryTitle()) {
            <div class="col-xs-12 sm:visible mt-16 mb-16">
                <div class="pr-body pl-body">
                    <div class="flex-vcenter content-center">
                        <h2 class="text-l ttu ellipsis blend-link" [ngClass]="currentCategoryFromABTest()?.className">
                            {{ categoryName() }}

                            @if (showDebugCategoryIds()) {
                                <category-debug [info]="'(' + currentCategoryFromABTest()?.id + ')'" [template]="'parenthesis'"></category-debug>
                            }
                        </h2>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
